import { type AppConfig, resolveConfig, withLibraryTypes } from '@echo/core';

/** Resolved once from Vite's build-time env (see .env.example). */
export const appConfig: AppConfig = withLibraryTypes(
  resolveConfig(import.meta.env.VITE_ECHO_ENV, {
    mockGroups:
      resolveConfig(import.meta.env.VITE_ECHO_ENV).environment === 'local' &&
      import.meta.env.VITE_MOCK_GROUPS === '1',
    onearlyApiUrl: import.meta.env.VITE_ONEARLY_API_URL,
    echoApiUrl: import.meta.env.VITE_ECHO_API_URL,
    strongerMemoryGroupActorUuid: import.meta.env.VITE_STRONGER_MEMORY_GROUP_UUID,
    posthog: import.meta.env.VITE_POSTHOG_API_KEY
      ? {
          apiKey: import.meta.env.VITE_POSTHOG_API_KEY,
          host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
        }
      : undefined,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    appVersion: __ECHO_VERSION__,
    buildHash: __ECHO_BUILD_HASH__,
    buildDate: __ECHO_BUILD_DATE__,
  }),
  import.meta.env.VITE_STRONGER_MEMORY_LIBRARY_TYPES,
);

/** `VITE_GROUP_CHAT=1`: group chat on Reach (docs/group-chat.md). Off unless the build set it. */
export const groupChatEnabled = import.meta.env.VITE_GROUP_CHAT === '1';
